(function () {
  'use strict';

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function initDirectory(root) {
    if (root.getAttribute('data-zm-directory-ready') === 'true') return;
    root.setAttribute('data-zm-directory-ready', 'true');

    var input = root.querySelector('[data-zm-house-search]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-zm-house-group]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.zm-inspired-house[data-zm-house-name]'));
    var count = root.querySelector('[data-zm-house-count] strong');
    var empty = root.querySelector('[data-zm-house-empty]');
    var groupIndex = root.querySelector('[data-zm-group-index]');
    var houseIndex = root.querySelector('[data-zm-house-index]');

    groups.forEach(function (group, index) {
      var label = cleanText(group.getAttribute('data-zm-house-group'));
      if (!label) {
        var heading = group.querySelector('h2, h3, .zamoori-abd-tier-title');
        label = cleanText(heading && heading.textContent) || ('Group ' + (index + 1));
      }
      if (!group.id) group.id = 'zm-inspired-group-' + (index + 1);
      if (groupIndex && !groupIndex.querySelector('a[href="#' + group.id + '"]')) {
        var link = document.createElement('a');
        link.className = 'zamoori-abd-seo-link';
        link.href = '#' + group.id;
        link.textContent = label;
        groupIndex.appendChild(link);
      }
    });

    var alphaCards = cards.slice().sort(function (a, b) {
      return cleanText(a.getAttribute('data-zm-house-name')).localeCompare(
        cleanText(b.getAttribute('data-zm-house-name')),
        undefined,
        { sensitivity: 'base' }
      );
    });
    alphaCards.forEach(function (card) {
      if (!houseIndex) return;
      var link = document.createElement('a');
      link.className = 'zamoori-abd-seo-link';
      link.href = card.getAttribute('href') || '#';
      link.textContent = cleanText(card.getAttribute('data-zm-house-name'));
      houseIndex.appendChild(link);
    });

    function filterDirectory() {
      var term = cleanText(input && input.value).toLocaleLowerCase();
      var visibleCount = 0;
      cards.forEach(function (card) {
        var name = cleanText(card.getAttribute('data-zm-house-name'));
        var matches = !term || (name + ' ' + card.textContent).toLocaleLowerCase().indexOf(term) !== -1;
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });
      groups.forEach(function (group) {
        var remaining = group.querySelectorAll('.zm-inspired-house[data-zm-house-name]:not([hidden])').length;
        group.hidden = remaining === 0;
        if (groupIndex) {
          var groupLink = groupIndex.querySelector('a[href="#' + group.id + '"]');
          if (groupLink) groupLink.hidden = group.hidden;
        }
      });
      root.querySelectorAll('[data-zm-house-index-name]').forEach(function (link) {
        link.hidden = cleanText(link.getAttribute('data-zm-house-index-name')).toLocaleLowerCase().indexOf(term) === -1;
      });
      if (count) count.textContent = String(visibleCount);
      if (empty) empty.hidden = visibleCount !== 0;
    }

    if (input) input.addEventListener('input', filterDirectory);
    filterDirectory();
  }

  function initGuide(root) {
    if (root.getAttribute('data-zm-guide-ready') === 'true') return;
    root.setAttribute('data-zm-guide-ready', 'true');

    var sidebar = root.querySelector('[data-zm-guide-sidebar]');
    var toc = root.querySelector('[data-zm-guide-toc]');
    var layout = root.querySelector('.zn-note-layout');
    if (!sidebar || !toc || !layout) return;
    if (!toc.querySelector('li a[href]')) {
      sidebar.hidden = true;
      layout.classList.add('zn-note-layout--no-toc');
    }
  }

  function hideLegacyEmptyTocs() {
    document.querySelectorAll('.zn-note-page .zn-note-layout').forEach(function (layout) {
      var sidebar = layout.querySelector('.zn-note-sidebar');
      if (!sidebar) return;
      // Facts sidebars are not TOCs and must remain visible.
      var toc = sidebar.querySelector('.zn-toc-list');
      if (!toc) return;
      var entries = toc.querySelectorAll('li a[href]');
      if (entries.length) return;
      sidebar.hidden = true;
      layout.classList.add('zn-note-layout--no-toc');
    });
  }

  function initAll() {
    var header = document.querySelector('header');
    if (header && !header.hasAttribute('data-zm-anchor-offset-ready')) {
      header.setAttribute('data-zm-anchor-offset-ready', 'true');
      var updateOffset = function () {
        document.documentElement.style.setProperty('--zm-guide-anchor-offset', String(Math.ceil(header.getBoundingClientRect().height) + 24) + 'px');
      };
      updateOffset();
      if ('ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
      else window.addEventListener('resize', updateOffset);
    }
    hideLegacyEmptyTocs();
    document.querySelectorAll('[data-zm-inspired-directory]').forEach(initDirectory);
    document.querySelectorAll('[data-zm-inspired-guide]').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
}());
